var requiredJSLoaded = false;

namespace Pages._Camera.Player.Test.Stream {

    export function onDocumentReady() {
        let controlDiv = $("<div style='display:none'>");

        let prodDiv = $(`<div style='margin-bottom:10px;display:inline-block;'><span style='width:100px;display:inline-block;'>ProductID&nbsp;</span></div>`);
        let prodTxt = $(`<input type='text' class='camera-request-productid' value='301' />`);
        prodDiv.append(prodTxt);
        controlDiv.append(prodDiv);

        let regDiv = $(`<div style='margin-bottom:10px;'><span style='width:100px;display:inline-block;'>Registration&nbsp;</span></div>`);
        let regTxt = $(`<input type='text' class='camera-request-registration' />`);
        regDiv.append(regTxt);
        controlDiv.append(regDiv);
        let requestBtn = $(`<button>Request</button>`);
        requestBtn.hide();
        let groupController: CDN.Camera.GroupController;

        let outstandingRequests: CDN.API.Camera.Player.v1.Request[] = [];
        let requestObj = {
            hasPlayed: false,
            requested: Date.now(),
            framecounts: Object.fromEntries(CDN.Camera.Player.CameraPlayers.map(cp => [cp._playerId, 0])),
        };

        let requestFn = async () => {
            /* Remove any old overlay messages */
            for (let player of CDN.Camera.Player.CameraPlayers) {
                player.removeOverlayMessages(msg => msg.owner == requestObj);
            }

            requestObj = {
                hasPlayed: false,
                requested: Date.now(),
                framecounts: Object.fromEntries(CDN.Camera.Player.CameraPlayers.map(cp => [cp._playerId, 0])),
            };

            for (let player of CDN.Camera.Player.CameraPlayers) {
                let start = new Date();
                start.setMilliseconds(0);
                let end = new Date(start).addSeconds(10);

                let request = (await CDN.API.Camera.Player.v1.getRequestsByPriorityAsync(
                    player.user, {
                    cameraId: player.cameraDetails.ID,
                    types: [CDN.API.Camera.SharedEnums.RequestType.LiveFeed],
                    dateTimeStart: null,
                    dateTimeEnd: null,
                    statuses: [0],
                    limit: 1
                }))?.[0];

                if (request == null) {
                    request = await CDN.API.Camera.Player.v1.createRequestAsync(
                        player.user,
                        {
                            cameraId: player.cameraDetails.ID,
                            start: start,
                            end: end,
                            type: CDN.API.Camera.SharedEnums.RequestType.LiveFeed
                        });
                }

                outstandingRequests.push(request);
                player.fetchFramesAsync({
                    requestId: request.id,
                    refreshTimeout: 1000,
                    onPeriodDetailFetched: periodDetail => {

                        const bufferFrames = 30;
                        const totalFrames = 40;
                        const timeout = 60000;

                        //Remove any non player messages
                        player.removeOverlayMessages(msg => msg.owner == requestObj);

                        let frameCount = periodDetail.frames.filter(f => f.type != CDN.API.Camera.Player.v1.FrameType.Pending).length;
                        requestObj.framecounts[player._playerId] = frameCount;

                        if (!requestObj.hasPlayed && /* Prevent auto-playing more than once */
                            (Date.now() - requestObj.requested > timeout || /* Auto play after timeout */ 
                                Array.all(CDN.Camera.Player.CameraPlayers, cp => requestObj.framecounts[cp._playerId] >= bufferFrames))) /* Auto play if enough frames received for all cameras */ {
                            requestObj.hasPlayed = true;
                            player.groupController.play();
                        }
                        else if (frameCount == 0) {
                            player.addOverlayMessage(new CDN.Camera.OverlayMessage(requestObj, `Connecting... <img width="10px" src='${CDN.cdnUrl}camera/player/images/loadinganim.gif'>`, CDN.Common.LogLevel.INFO));
                        }
                        else if (frameCount < 40) {
                            player.addOverlayMessage(new CDN.Camera.OverlayMessage(requestObj, `Buffering ${Math.min(Math.floor(frameCount / totalFrames * 100), 100)}% <img width="10px" src='${CDN.cdnUrl}camera/player/images/loadinganim.gif'>`, CDN.Common.LogLevel.INFO));
                        }
                    },
                    onComplete: () => {
                        //Remove completed request from outstanding requests
                        outstandingRequests = outstandingRequests.filter(r => r.id != request.id);

                        //If no longer any outstanding requests, enable the request button
                        if (outstandingRequests.length == 0) {
                            requestBtn.prop('disabled', false);
                        }
                    }
                });
            }
        };

        requestBtn.click(e => {
            e.preventDefault();
            e.stopPropagation();

            requestBtn.prop('disabled', true);

            requestFn();
        });

        controlDiv.append(prodDiv, regDiv, requestBtn);

        $("body").append(controlDiv);

        let lightDiv = $("<div style='padding: 20px;'>");
        $("body").append(lightDiv);

        let login = new CDN.Controls.Login(document.body, {
            onError: (err) => {
                console.error(err);
            },
            onLogin: (result) => {
                controlDiv.show();
                login.hide();
                regTxt.autocomplete({
                    source: function (request, response) {
                        CDN.API.AutoComplete.v1.searchVehiclesAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, regTxt.val()).then(success => {
                            response($.map(success, function (item) {
                                return {
                                    label: item.Registration,
                                    vehicleId: item.VehicleId,
                                    registration: item.Registration,
                                    fleetNum: item.Fleetnum,
                                    product: "",
                                    productid: prodTxt.val(),
                                    usertoken: result.UserToken,
                                    departId: item.DepartId,
                                    depotId: item.DepotId,
                                };
                            }));
                        }, err => {
                        });
                    },
                    minLength: 3,
                    open: function () { $(this).removeClass("ui-corner-all").addClass("ui-corner-top"); },
                    select: function (event, ui) {
                        let registration = ui.item.value;
                        let vehicleId = ui.item.vehicleId;
                        let fleetNum = ui.item.fleetNum;

                        lightDiv.empty();
                        groupController?.destroy();

                        let controllerDiv = $("<div>");
                        lightDiv.append(controllerDiv);
                        groupController = new CDN.Camera.GroupController(controllerDiv.get(0), {
                            groupName: "Test Players",
                        });

                        CDN.API.Camera.Player.v1.getActiveVehicleCamerasAsync({
                            productId: prodTxt.val(),
                            userToken: result.UserToken,
                        }, vehicleId).then(cameras => {
                            for (let camera of cameras) {
                                let camDiv = $("<div style='display:inline-block'>");
                                let lightCameraPlayer: CDN.Camera.Player = new CDN.Camera.Player(camDiv, {
                                    productId: prodTxt.val(),
                                    userToken: result.UserToken,
                                }, camera,
                                    {
                                        timeZone: 0,
                                        showControls: false,
                                        showPlayBackBar: false,
                                        groupController: groupController,
                                    });

                                lightDiv.append(camDiv);
                            }

                            requestBtn.prop('disabled', false);
                            requestBtn.show();
                            /*lightDiv.append("<div style='height:1200px;width:100%;background-color:#EEEEEE;display:block;'></div>");*/
                        });
                    },
                    close: function () { $(this).removeClass("ui-corner-top").addClass("ui-corner-all"); }
                });
            },
        });
    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.JQuery_UI, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Control_UI_TimePicker, },
    { code: CDN.PackageCode.Camera_Player, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages._Camera.Player.Test.Stream.onDocumentReady);
});